import React, { useMemo } from "react";
import FileViewer from "@file-viewer/react";
import officePreset from "@file-viewer/preset-office";

const viewerOptions = {
  preset: officePreset,
  rendererMode: "replace",
  theme: "light",
  toolbar: { position: "bottom-right" },
  search: { enabled: true },
};

/**
 * OfficeViewer - Renders Office documents (DOCX, XLSX, PPTX, etc.) in the browser
 * using Flyfish Viewer. No server-side conversion required.
 *
 * @param {string} fileUrl - Internal URL of the file to render (same as used for PDF)
 * @param {string} height - CSS height of the viewer container (default: "100%")
 */
const OfficeViewer = ({ fileUrl, height = "100%" }) => {
  const style = useMemo(() => ({ height, width: "100%" }), [height]);

  if (!fileUrl) return null;

  return (
    <div style={style}>
      <FileViewer url={fileUrl} options={viewerOptions} />
    </div>
  );
};

export default React.memo(OfficeViewer);
